import Emoji from 'common/emoji'

import { messages } from '../WidgetMessage'

const Error = () => (
  <div className="flex justify-center items-center h-36 bg-coolGray-50 rounded-b border-coolGray-100 border-t">
    <Emoji symbol="🙀" className="mr-8 text-5xl text-black" />
    <p className="text-red-500 max-w-125">{messages.error}</p>
  </div>
)

export default Error
